export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/alfa-loader.7e965d69.gif","height":89,"width":80,"blurWidth":0,"blurHeight":0};